import { Component } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'ingo-app',
  template: `
    <ng-container *ngIf="this.router.url.includes('/mastercard-landing-page'); else mainApp">
      <ingo-mastercard-landing-page></ingo-mastercard-landing-page>
    </ng-container>
    <ng-template #mainApp>
      <ingo-main-app></ingo-main-app>
    </ng-template>
  `
})
export class AppComponent {

  constructor(
      public router: Router
  ) { }
}
